import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { ButtonComponent, DropdownComponent } from 'shared';
import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { DropdownItem, NavMenuItem, shouldShowNavItem } from '../nav.component';
import { UserMenuComponent } from './user-menu/user-menu.component';

@Component({
  selector: 'app-nav-deskop',
  imports: [FeatherModule, TranslateModule, DropdownComponent, RouterLink, UserMenuComponent],
  templateUrl: './nav-deskop.component.html',
  styleUrl: './nav-deskop.component.scss',
})
export class NavDeskopComponent {
  menuItems = input<NavMenuItem[]>([]);
  isLoggedIn = input<boolean>(false);

  private router = inject(Router);
  private translate = inject(TranslateService);
  private authService = inject(AuthService);

  showMenuItems = computed(() => {
    const items = this.menuItems();
    const isAuthenticated = this.authService.isAuthenticated();

    const visibleItems = items.filter((item) => item && shouldShowNavItem(item, isAuthenticated));
    const result = visibleItems.length > 0;

    return result;
  });

  shouldShowItem(item: NavMenuItem): boolean {
    return shouldShowNavItem(item, this.authService.isAuthenticated());
  }

  login() {
    this.router.navigate(['/login']);
  }

  getDropdownItems(menuItem: NavMenuItem): DropdownItem[] {
    return (menuItem.options || []).map((option) => ({
      label: option.label,
      value: option.value || option.label,
      routerLink: option.route,
      isExternal: option.external,
    }));
  }

  onDropdownItemSelect(value: string, menuItem: NavMenuItem) {
    const selectedItem = menuItem.options?.find((item) => (item.value || item.label) === value);

    if (selectedItem?.route) {
      if (selectedItem.external) {
        this.openInNewTab(selectedItem.route.join('/'));
      } else {
        this.router.navigate(selectedItem.route);
      }
    } else if (selectedItem?.click) {
      selectedItem.click();
    }
  }

  openInNewTab(url: string) {
    window.open(url, '_blank');
  }

  getLoginRegisterButtonLabel(): string {
    const currentUrl = this.router.url;
    return currentUrl.includes('register')
      ? this.translate.instant('login')
      : this.translate.instant('register');
  }

  onLoginRegisterClick(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('register')) {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/register']);
    }
  }
}
